/**
 * Upload Wrapper - Switches between upload system implementations
 *
 * Supports three modes:
 * 1. Secure Mode (USE_SECURE_UPLOAD_MODE): Presigned URLs, no AWS credentials in client
 * 2. New Mode (USE_NEW_UPLOAD_SYSTEM): Direct S3 with AWS SDK (current default)
 * 3. Legacy Mode: Original upload implementation (fallback)
 */
import { uploadLargeFile as uploadLargeFileOld } from 'utils/uploadUtils';
import { UPLOAD_CONFIG } from '../Config/uploadConfig';
// import { uploadLargeFileNew } from './uploadManagerNew';
import { uploadLargeFileSecure } from './uploadManagerSecure';

/**
 * Unified upload function that uses feature flags to switch between implementations
 */
export async function uploadLargeFile(options) {
  // Priority 1: Secure mode (presigned URLs, no exposed credentials)
  if (UPLOAD_CONFIG.USE_SECURE_UPLOAD_MODE) {
    console.log('[Upload] Using SECURE upload system with presigned URLs');
    console.log('[Upload] Backend service: uploader.projector.app');
    return uploadLargeFileSecure(options);
  }

  // Priority 2: New upload system (current default, uses AWS SDK)
  // if (UPLOAD_CONFIG.USE_NEW_UPLOAD_SYSTEM) {
  //   console.log('[Upload] Using NEW upload system - Direct S3 with AWS SDK');
  //   return uploadLargeFileNew(options);
  // }

  // Priority 3: Legacy system (fallback)
  console.log('[Upload] Using LEGACY upload system');
  // Legacy system expects draft_id (underscore), new system uses draftId (camelCase)
  // Transform parameter for backward compatibility
  const legacyOptions = {
    ...options,
    draft_id: options.draftId || options.draft_id,
  };
  return uploadLargeFileOld(legacyOptions);
}

export default uploadLargeFile;
